import store from "@/store";
export default {
	languages: {
	},
	language_current: 'uz',
	apiV3: "api/v3",
	secApiUrl: null,
	message: {},
	host: null,
	location: {},
	list: [],
	lastMessage: {},
	roles: {},
	courses: {},
	stats: [],
	routes: [],
	seasons: [],
	routesRoot: [
		{
			"id": 1001,
			"name": "Должности",
			"title": "Должности",
			"path": "jobspositions",
			"position": 5,
			"icon": null
		}
	],
	shedules: {},
	language: 'ru',
	checked: null,
	business: null,
	root: false,
	text: {},
	user: null,
	newOrder: null,
	modals: {
		business: {
			modalCreate: "business",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: true,
			removeLink: "",
			cardLink: "item_business",
			itemLink: "businesses",
			setLink: "businesses",
			columns: [
				{
					key: "title",
					title: "Наименование",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
			],
			params: null
		},
		schedule: {
			modalCreate: "schedule",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: true,
			removeLink: "",
			cardLink: "item_schedule",
			itemLink: "business/schedules",
			setLink: "business/schedules",
			columns: [
				{
					key: "position",
					title: "Номер урока",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
				{
					key: "from_at",
					title: "С",
					control: false,
					align: "left",
					timer: false,
				},
				{
					key: "till_at",
					title: "По",
					control: false,
					align: "left",
					timer: false,
				},
			],
			params: {
			}
		},
		course: {
			modalCreate: "course",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: true,
			removeLink: "",
			cardLink: "item_course",
			itemLink: "courses",
			setLink: "courses",
			columns: [
				{
					key: "title",
					title: "Номер курса",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
			],
			params: {
			}
		},
		discipline: {
			modalCreate: "discipline",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: false,
			removeLink: "",
			cardLink: "item_discipline",
			itemLink: "disciplines",
			setLink: "disciplines",
			columns: [
				{
					key: "title",
					title: "Название дисциплины",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
			],
			params: {
			}
		},
		category: {
			modalCreate: "category",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: false,
			removeLink: "",
			cardLink: "item_category",
			itemLink: "categories",
			setLink: "categories",
			columns: [
				{
					key: "title",
					title: "Название",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
			],
			params: {
			}
		},
		// timetable: {
		//     modalCreate: "category",
		//     fields: [

		//     ],
		//     isAdd: false,
		//     openItem: false,
		//     isUpdate: true,
		//     searchDisable: false,
		//     removeLink: "",
		//     cardLink: "",
		//     itemLink: "",
		//     setLink: "",
		//     columns: [
		//         {
		//             key: "date",
		//             title: "День",
		//             checkbox: true,
		//             dateFormat: true,
		//             control: false,
		//             align: "left",
		//             timer: false,
		//         },
		//         {
		//             key: "schedule",
		//             object: "position",
		//             title: "Номер урока",
		//             checkbox: false,
		//             disableLink: true,
		//             control: false,
		//             align: "left",
		//             timer: false,
		//         },
		//     ],
		//     params: null
		// },
		business_discipline: {
			modalCreate: "discipline",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: false,
			removeLink: "",
			cardLink: "item_discipline",
			itemLink: "business/disciplines",
			setLink: "business/disciplines",
			columns: [
				{
					key: "title",
					title: "Название дисциплины",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
			],
			params: null
		},
		lessonplan: {
			modalCreate: "lessonplan",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: false,
			removeLink: "",
			cardLink: "item_lessonplan",
			itemLink: "lessonplans",
			setLink: "lessonplans",

			columns: [
				{
					key: "position",
					title: "Номер темы",
					checkbox: false,
					sortBy: 'position'
				},
				{
					key: "title",
					title: "Плановый урок",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
				{
					key: "discipline",
					title: "Предмет",

					control: false,
					object: "title",
					disableLink: true,
					timer: false,
				},
				{
					key: "course",
					title: "Класс",
					control: false,
					object: "position",
					timer: false,
					disableLink: true,
				},
				{
					key: "locale",
					title: "Локализация",
					control: false,
					object: "position",
					timer: false,
					disableLink: true,
				},
			],
			params: {
				order: '-position'
			}
		},
		season: {
			modalCreate: "season",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: true,
			removeLink: "",
			cardLink: "item_season",
			itemLink: "business/seasons",
			setLink: "business/seasons",
			columns: [
				{
					key: "title",
					title: "Название дисциплины",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
			],
			params: null
		},
		group: {
			modalCreate: "group",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: true,
			removeLink: "",
			cardLink: "item_group",
			itemLink: "business/groups",
			setLink: "business/groups",
			columns: [
				{
					key: "title",
					title: "Класс",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
			],
			params: null
		},
		client: {
			modalCreate: "client",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: false,
			removeLink: "",
			cardLink: "item_client",
			itemLink: "business/clients",
			setLink: "business/clients",
			columns: [
				{
					key: "id",
					title: "ID",
					control: false,
					align: "left",
					timer: false,
				},
				{
					key: "full_name",
					title: "ФИО",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
				{
					key: "phone",
					title: "Номер телефона",
					control: false,
					align: "left",
					timer: false,
				},
			],
			params: {
			}
		},
		client_cloud: {
			modalCreate: "client",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: false,
			removeLink: "",
			cardLink: "item_client",
			itemLink: "clients",
			setLink: "clients",
			columns: [
				{
					key: "full_name",
					title: "ФИО",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
				{
					key: "phone",
					title: "Номер телефона",

					control: false,
					align: "left",
					timer: false,
				},
			],
			params: {
			}
		},
		customer: {
			modalCreate: "client",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: false,
			removeLink: "",
			cardLink: "item_customer",
			itemLink: "business/customers",
			setLink: "business/customers",
			columns: [
				{
					key: "full_name",
					title: "ФИО",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
				{
					key: "phone",
					title: "Номер телефона",

					control: false,
					align: "left",
					timer: false,
				},


			],
			params: {
			}
		},
		guardian: {
			modalCreate: "guardian",
			fields: [
				{
					col: 'col-12 col-md-6',
					key: "phone",
					label: "Номер телефона",
					type: "mask",
					mask: "+998#########",
					placeholder: '+998'
				},
				{
					col: 'col-12 col-md-6',
					key: "last_name",
					label: "Фамилия",
					type: "field",
				},
				{
					col: 'col-12 col-md-6',
					key: "first_name",
					label: "Имя",
					type: "field",
				},
				{
					col: 'col-12 col-md-6',
					key: "father_name",
					label: "Отчество",
					type: "field",
				},

			],
			isAdd: true,
			openItem: false,
			isUpdate: true,
			searchDisable: false,
			removeLink: "",
			cardLink: "item_guardian",
			itemLink: "business/guardians",
			setLink: "business/guardians",
			columns: [
				{
					key: "full_name",
					title: "ФИО",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
				{
					key: "phone",
					title: "Номер телефона",
					control: false,
					align: "left",
					timer: false,
				},

			],
			params: {
			}
		},
		guardian_cloud: {
			modalCreate: "guardian",
			fields: [
				{
					col: 'col-12 col-md-6',
					key: "phone",
					label: "Номер телефона",
					type: "mask",
					mask: "+998#########",
					placeholder: '+998'
				},
				{
					col: 'col-12 col-md-6',
					key: "last_name",
					label: "Фамилия",
					type: "field",
				},
				{
					col: 'col-12 col-md-6',
					key: "first_name",
					label: "Имя",
					type: "field",
				},

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			openItem: false,
			searchDisable: true,
			removeLink: "",
			cardLink: "item_guardian",
			itemLink: "guardians",
			setLink: "guardians",
			columns: [
				{
					key: "full_name",
					title: "ФИО",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
				{
					key: "phone",
					title: "Номер телефона",
					control: false,
					align: "left",
					timer: false,
				},

			],
			params: null
		},
		jobposition: {
			modalCreate: "jobposition",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: true,
			removeLink: "",
			cardLink: "",
			itemLink: `${process.env.HOST_URL}/api/v3/school/positions`,
			setLink: `${process.env.HOST_URL}/api/v3/school/positions`,
			columns: [
				{
					key: "name",
					title: "Должность",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
			],
			params: {
			}
		},
		role: {
			modalCreate: "role",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: true,
			removeLink: "",
			cardLink: "",
			itemLink: "roles",
			setLink: "roles",
			columns: [
				{
					key: "title",
					title: "Роль",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
			],
			params: {
			}
		},
		timetable: {
			modalCreate: "work",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: true,
			removeLink: "",
			cardLink: "",
			itemLink: "business/teacher_groups",
			setLink: "business/teacher_groups",
			columns: [
				{
					key: "date",
					title: "Дата",
					checkbox: true,
					control: false,
					align: "left",

					dateFormat: true,
				},
			],
			params: {
				day: 3
			}
		},
		seasons: {
			modalCreate: "seasonsz",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: true,
			removeLink: "",
			cardLink: "",
			itemLink: "",
			setLink: "",
			columns: [
				// {
				// 	key: "id",
				// 	title: "ID",
				// 	control: false,
				// 	align: "left",
				// 	timer: false,
				// },
				{
					key: "title",
					title: "Название",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
				// {
				// 	detail: true
				// }
			],
			params: {
				//day: 3
			}
		},
		work: {
			modalCreate: "work",
			fields: [
				{
					col: 'col-12 col-md-8',
					key: "title",
					label: "Название",
					type: "field",
					textType: "text",

				},

				{
					col: 'col-12 col-md-4',
					key: "given_seconds",
					label: "Сколько секунд на решение",
					type: "mask",
					mask: '###',
					textType: "number",
				},
				{
					col: 'col-12 col-md-12',
					key: "description",
					label: "Краткое описание задания",
					type: "textarea",
					textType: "text",

				},
			],
			isAdd: true,
			openItem: false,
			isUpdate: true,
			searchDisable: true,
			removeLink: "",
			cardLink: "",
			itemLink: "work_clouds",
			setLink: "work_clouds",
			columns: [
				{
					key: "title",
					title: "Название",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
			],
			params: null
		},
		work_view: {
			modalCreate: "work_view",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: true,
			removeLink: "",
			cardLink: "item_work_view",
			itemLink: "business/works",
			setLink: "business/works",
			columns: [
				{
					key: "title",
					title: "Название",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
				{
					detail: true
				}
			],
			params: null
		},

		books: {
			modalCreate: "books",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: false,
			searchDisable: false,
			removeLink: "",
			cardLink: "item_discipline",
			itemLink: "",
			setLink: "",
			columns: [
				{
					key: "file_name",
					title: "Учебник",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
			],
			params: {
			}
		},
		theme: {
			modalCreate: "lessonplan",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: false,
			removeLink: "",
			cardLink: "item_theme",
			itemLink: "lessonplans",
			setLink: "lessonplans",
			columns: [
				{
					key: "position",
					title: "Номер темы",
					checkbox: false,
					sortBy: 'position'
				},
				{
					key: "title",
					title: "Плановый урок",
					checkbox: true,
					control: false,
					align: "left",
					timer: false,
				},
				{
					key: "discipline",
					title: "Предмет",

					control: false,
					object: "title",
					disableLink: true,
					timer: false,
				},
				{
					key: "course",
					title: "Класс",
					control: false,
					object: "position",
					timer: false,
					disableLink: true,
				},
				{
					key: "locale",
					title: "Локализация",
					control: false,
					object: "position",
					timer: false,
					disableLink: true,
				},
			],
			params: {
				order: '-position',
				type: 'theme-material'
			}
		},

		author: {
			modalCreate: "author",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: true,
			removeLink: "",
			cardLink: "",
			itemLink: "authors",
			setLink: "authors",
			columns: [
				{
					checkbox: true,
					key: "first_name",
					title: "Имя",
				},
				{
					key: "last_name",
					title: "Фамилия",
				},
			],
			params: null
		},
		coursesModal: {
			modalCreate: "coursesModal",
			fields: [

			],
			isAdd: false,
			openItem: false,
			isUpdate: true,
			searchDisable: true,
			removeLink: "",
			cardLink: "",
			itemLink: "system",
			setLink: "system",
			columns: [
				{
					checkbox: true,
					key: "position",
					title: "Класс",
				},
				// {
				// 	key: "last_name",
				// 	title: "Фамилия",
				// },
			],
			params: {}
		},



	},
	modalName: null,
	valueSelected: null,
	lastUpdate: null,
	items: {
		//FOR ROOT
		item_books: 'Books',
		item_lessonplan: 'Lessonplan',
		item_theme: 'Theme',
		item_subtheme: 'Subtheme',
		item_discipline: 'Discipline',
		item_business: 'Business',
		item_customer_cloud: 'CustomerCloud',
		item_client_cloud: 'ClientCloud',
		item_guardian_cloud: 'GuardianCloud',
		item_customer: 'Customer',
		item_timetable: 'Timetable',
		item_client: 'Client',
		item_guardian: 'Guardian',
		//FOR BUSINESSES
		item_season: 'Season',
		item_schedule: 'Schedule',
		item_group: 'Group',
		item_group_course: 'GroupCourse',
		item_group_customer: 'GroupCustomer',
		item_notification: 'Notification',
		item_conference: 'Conference',
		item_part: 'Part',
		item_work: 'Work',
		item_log: 'Log',
		item_address: 'Address',
		item_text: 'Text',
		item_category: 'Category',
		item_process: 'Process',
		item_group_division: 'Division',

		item_transaction: 'Transaction',
		item_payment: 'Payment',
		item_tariff: 'Tariff',
		item_homework: 'Homework',
		item_holiday: 'Holiday',
		item_work_view: 'WorkView',
		item_author: 'Author',
		item_jobs_positions: 'JobsPositions',

		item_lessonplan_list: 'LessonplanList',
		item_lessonplan_detail: 'LessonplanDetail',
		item_author_lessonplan: 'AuthorLessonplan',
		// item_question: 'Question',
	}

}
